export default function TaxiLogo({ compact = false, className = '', subtitle = 'ISTRIA TRANSFERS' }) {
  if (compact) {
    return (
      <div className={`taxi-logo taxi-logo--compact ${className}`.trim()}>
        <span className="taxi-logo-name">RADENOVIĆ</span>
        <span className="taxi-logo-rule" aria-hidden="true" />
        <span className="taxi-logo-sub">{subtitle}</span>
      </div>
    );
  }

  return (
    <div className={`taxi-logo taxi-logo--full ${className}`.trim()}>
      <span className="taxi-logo-name">RADENOVIĆ</span>
      <span className="taxi-logo-rule" aria-hidden="true" />
      <span className="taxi-logo-sub">{subtitle}</span>
    </div>
  );
}
